

export default {
  props: ['blok']
}
